import { Fade } from "react-awesome-reveal";
import BadIcon from "../../../../assets/newresult/bad.svg";
import GoodIcon from "../../../../assets/newresult/good.svg";
import RateImage from "../../../../assets/newresult/rating.svg";
import HealthChecklistImage from "../../../../assets/icons/health-checklist.png";
import TestTitle from "../../testCommon/TestTitle";

const ExclusiveAnalysis = ({ testResults, testInfo, footerButtons }: any) => {
  const is_pro = testInfo.is_pro_analysis;
  const healthScore = testResults?.general_score;

  if (testInfo.gender === "MALE") {
    delete testResults.panel_advice["روتین بارداری"];
  }

  const checkList = [
    {
      enTitle: "diabetes",
      title: "دیــابت",
      value: "negative",
    },
    {
      enTitle: "anemia",
      title: "کم‌خـــونی",
      value: "negative",
    },
    {
      enTitle: "kidney",
      title: "مشکل در کلــیه‌ها",
      value: "negative",
    },
    {
      enTitle: "fat",
      title: "چربــی خون",
      value: "negative",
    },
    {
      enTitle: "thyroid",
      title: "تیـــروئید",
      value: "negative",
    },
    {
      enTitle: "hepatic",
      title: "مشکل در کبــد",
      value: "negative",
    },
    {
      enTitle: "vitamins",
      title: "ویتامــین‌ها",
      value: "negative",
    },
    {
      enTitle: "inflammation",
      title: "التهــاب و عفونت",
      value: "negative",
    },
    {
      enTitle: "urinary_tract_infection",
      title: "عفونــت مجاری ادراری",
      value: "negative",
    },
    {
      enTitle: "blood_pressure",
      title: "فشــار خون",
      value: "negative",
    },
    {
      enTitle: "gastrointestinal_infections",
      title: "عفــونت‌های گوارشی",
      value: "negative",
    },
    {
      enTitle: "inflammatory_bowel_diseases",
      title: "بیماری‌های التــهابی روده",
      value: "negative",
    },
  ];

  const updatedCheckList = checkList.map((item) => {
    const diseaseInfo =
      testResults?.disease_checklist[item.enTitle.toLowerCase()];
    return diseaseInfo
      ? { ...item, value: "positive", info: diseaseInfo }
      : item;
  });

  return (
    <Fade triggerOnce>
      <div>
        <div className="relative overflow-hidden flex-1 mb-14">
          <div className="absolute -left-14 lg:left-5 bottom-0">
            <img src={RateImage} className="w-9/12 lg:w-full" />
          </div>
          <div className="flex-1 py-4 px-6 lg:px-10 lg:py-5 bg-white border rounded-xl flex items-center">
            <div>
              <div>
                <h1 className="font-rokh font-[900] text-xl mt-4">
                  امتیاز وضعیت سلامت شما
                </h1>
                {is_pro ? (
                  <p className="font-rokh font-[700] text-sm lg:text-base">
                    بر اساس این آزمایش و سوالاتی که ازتون پرسیدیم، به وضعیت
                    سلامتی شما یه امتیاز دادیم.
                  </p>
                ) : (
                  <p className="font-rokh font-[700] text-sm lg:text-base">
                    اگه تحلیل پیشرفته رو انتخاب کنی، ما می‌تونیم به وضعیت
                    سلامتیت یه امتیاز بدیم که با توجه به اون شرایط خودت رو
                    بسنجی.
                  </p>
                )}
              </div>

              <div className="mt-8 mb-4">
                <h6 className="text-lg lg:text-2xl font-rokh font-[900] bg-pr_blue inline px-8 pt-3 pb-2 rounded-xl">
                  <strong className="text-lg lg:text-2xl font-rokh font-[900]">
                    {is_pro ? healthScore : "?"}{" "}
                  </strong>
                  از 100
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>

      {Object.entries(testResults?.panel_advice).length > 0 && (
        <div>
          <TestTitle
            title="پنل‌های آزمایش شما"
            subtitle="بررسی فاکتورهای آزمایش شما در قالب پنل‌ها"
            icon={HealthChecklistImage}
          />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
            {testResults?.panel_advice &&
              Object.entries(testResults?.panel_advice).map(
                ([testName, data]: any, idx) => {
                  const totalItems = data.total_count;
                  const abnormalItems = data.unnormal_component_name.length;
                  let isGood = true;
                  if (totalItems === 1) {
                    isGood = abnormalItems === 0;
                  } else {
                    isGood = abnormalItems <= 2;
                  }

                  return (
                    <div
                      key={testName}
                      className={`p-5 relative rounded-xl overflow-hidden ${
                        !is_pro && idx !== 0
                          ? "bg-gray-100"
                          : isGood
                          ? "bg-pr_green"
                          : "bg-pr_red"
                      }`}
                    >
                      {!is_pro && idx !== 0 && (
                        <div className="absolute left-0 top-0 h-full w-full backdrop-blur"></div>
                      )}

                      <div className="flex items-center">
                        <div className="ml-2">
                          {isGood ? (
                            <img src={GoodIcon} className="w-10 h-10" />
                          ) : (
                            <img src={BadIcon} className="w-10 h-10" />
                          )}
                        </div>
                        <h2 className="flex-1 font-rokh font-[900] mt-2 flex items-center">
                          {!is_pro && idx !== 0 ? "عنوان پنل" : testName}
                        </h2>

                        <div className="flex items-center justify-start">
                          <h5 className="font-bold text-xl">
                            {!is_pro && idx !== 0 ? "-" : data.normal_count}
                          </h5>
                          <span className="font-bold text-xl mr-1">
                            از {!is_pro && idx !== 0 ? "-" : data.total_count}
                          </span>
                        </div>
                      </div>
                      <p className="text-sm font-rokh font-[700] mt-1 mr-2">
                        {!is_pro && idx !== 0
                          ? "برای بررسی وضعیت پنل، تحلیل پیشرفته رو انتخاب کن"
                          : isGood
                          ? "وضعیت این پنل در محدوده نرمال قرار داره."
                          : "بهتره با یه پزشک درباره این پنل مشورت کنی"}
                      </p>

                      <p className="text-sm mt-5">
                        {!is_pro && idx !== 0
                          ? "برای بررسی و دونستن توضیحات مربوط به پنل، تحلیل پیشرفته رو انتخاب کن."
                          : data.description}
                      </p>

                      <div className="flex items-center flex-wrap gap-1 mt-5">
                        {data?.component_names.map((component: any) => {
                          return (
                            <div
                              key={component}
                              className={`flex justify-start items-center ${
                                data.normal_component_name.includes(component)
                                  ? "text-green-500"
                                  : "text-red-500"
                              }`}
                            >
                              <h4 className="bg-white rounded-lg px-2 pt-2 pb-1 font-rokh font-[700] text-xs">
                                {!is_pro && idx !== 0 ? "--" : component}
                              </h4>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                }
              )}

            {!is_pro && (
              <div className=" p-5 relative rounded-xl overflow-hidden bg-gray-100">
                <p className="font-rokh font-[700] text-center pt-2 pb-12 lg:pb-4 lg:pt-5">
                  برای این آزمایش پنل‌های دیگه هم بررسی شده، برای دیدنشون
                  می‌تونی تحلیل پیشرفته رو انتخاب کنی.
                </p>
              </div>
            )}
          </div>
        </div>
      )}

      <div
        className={`${
          Object.entries(testResults?.panel_advice).length > 0 ? "mt-16" : ""
        }`}
      >
        <TestTitle
          title="چک‌ لیست سلامت"
          subtitle=" براتون احتمال تعدادی از بیماری‌های رایج رو بررسی کردیم، دقت کنید که این موارد صرفا احتمال هستن و برای تایید حتما باید از پزشک متخصص مشورت بگیرید.  "
          icon={HealthChecklistImage}
        />

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-4 gap-2">
          {updatedCheckList.map((item: any, idx: number) => (
            <div
              key={item.title}
              className={`relative rounded-xl py-3 px-6 ${
                !is_pro && idx !== 0
                  ? "bg-gray-200"
                  : item.value === "negative"
                  ? "bg-pr_green"
                  : "bg-pr_red"
              }`}
            >
              <div className="flex items-center justify-between my-3">
                <h3 className="font-rokh font-[900] mt-2">{item.title}</h3>
                <p className="font-rokh font-[900] mt-2">
                  {!is_pro && idx !== 0
                    ? ""
                    : item.value === "negative"
                    ? "منفی"
                    : "نیاز به بررسی"}
                </p>
              </div>
              <p className="text-sm font-rokh font-[700]">
                {!is_pro && idx !== 0
                  ? "توی تحلیل پیشرفته می‌تونیم وضعیت این بیماری رو بهت بگیم."
                  : item.info
                  ? item.info
                  : "بر اساس این آزمایش و سوال‌ها، احتمال این بیماری پایین است."}
              </p>
            </div>
          ))}
        </div>
      </div>

      {footerButtons}
    </Fade>
  );
};

export default ExclusiveAnalysis;
